import React from 'react';

/**
 * Avatar component for displaying RE/MAX balloon logo
 * Used in the header to show the RE/MAX branding
 */
export default function AgentAvatar({ name = "Open Houses", size = 40 }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        cursor: 'default',
        transition: 'transform 0.2s ease'
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
      title="RE/MAX"
    >
      <img
        src="/images/rmxballoons.png"
        alt="RE/MAX Balloon Logo"
        style={{
          width: '140%',
          height: '140%',
          objectFit: 'contain'
        }}
        onError={(e) => {
          // Fallback to text if image fails to load
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'flex';
        }}
      />
      <div
        style={{
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          backgroundColor: '#1e40af',
          color: 'white',
          display: 'none',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: size * 0.4,
          fontWeight: 'bold'
        }}
      >
        OH
      </div>
    </div>
  );
}
